import { useParams } from "react-router-dom";
import { m } from "framer-motion";
import { Col } from "react-bootstrap";
import { useQuery } from "@tanstack/react-query";
import {
  getMeetingMinutes,
  getPad,
  getProjectDocuments,
  getStudyReports,
} from "../../Store/Publication/publication";
import Loading from "../../Components/Loading";
import Tiles from "./Components/Tiles";
const DocumentRepository = () => {
  const { title } = useParams();
  const heading =
    title === "project-appraisal-document"
      ? "Project Appraisal Document"
      : title === "meeting-minutes"
      ? "Meeting Minutes"
      : title === "project-documents"
      ? "Project Documents"
      : title === "reports" && "Reports";
  const { data: padData, isLoading: isLoadingPad } = useQuery({
    queryKey: ["padData"],
    queryFn: getPad,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: title === "project-appraisal-document",
  });

  const { data: meetingMinutesData, isLoading: isLoadingMeetingMinutes } =
    useQuery({
      queryKey: ["meetingMinutesData"],
      queryFn: getMeetingMinutes,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      enabled: title === "meeting-minutes",
    });

  const { data: projectDocumentsData, isLoading: isLoadingProjectDocuments } =
    useQuery({
      queryKey: ["projectDocumentsData"],
      queryFn: getProjectDocuments,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      enabled: title === "project-documents",
    });

  const { data: studyReportsData, isLoading: isLoadingStudyReports } = useQuery(
    {
      queryKey: ["studyReportsData"],
      queryFn: getStudyReports,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      enabled: title === "reports",
    }
  );
  if (
    isLoadingPad ||
    isLoadingStudyReports ||
    isLoadingMeetingMinutes ||
    isLoadingProjectDocuments
  )
    return <Loading />;
  return (
    <>
      <m.div className="container  mt-[200px] mb-[50px] ">
        <Col xl={8} lg={10} className="text-center w-fit">
          <h3 className="font-serif text-[30px] mb-[2px]  font-medium text-[#146084] -tracking-[1px]">
            {heading}
          </h3>
          <m.div
            className="border-b border-1 w-[40%] border-[#146084]"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          />
        </Col>
        { title === "project-appraisal-document" && (
          <Tiles data={padData?.data} />
        )}
        {title === "meeting-minutes" && (
          <Tiles data={meetingMinutesData?.data} />
        )}
        {title === "project-documents" && (
          <Tiles data={projectDocumentsData?.data} />
        )}
        {title === "reports" && (
          <Tiles data={studyReportsData?.data} />
        )}
      </m.div>
    </>
  );
};

export default DocumentRepository;
